//import { logDOM } from '@testing-library/react';
import { Component } from 'react';

//import logo from './logo.svg';
import './App.css';
import CardList from './components/card-list/card-list.component';
import SearchBox from './components/search-box/search-box.component';
import Footer from './components/footer/footer.component';

class App extends Component {
  constructor() {
    super();
    
    this.state = {
      monsters: [],
      searchString:'',  
    };
  }

  componentDidMount() {
    
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => response.json())
      .then((users) => this.setState(() => {
        return (
          { monsters: users }
        )
      }));
  }
  onSearchChange = (event) => {
    const searchString = event.target.value.toLowerCase();
   
    this.setState(() => {
      return { searchString };
    })
  }

  render() {
    console.log("render in App");
    const {monsters , searchString} = this.state;
    const {onSearchChange}= this;
    const filteredMonsters = monsters.filter((monster) => { 
      return monster.name.toLowerCase().includes(searchString); }
    );
    
    return (
      <div className="App">
        <div className='Nav-bar'>
        <h1 className='app-title'>Monster Rolodex</h1>
        <SearchBox className='search-box' onChangeHandler={onSearchChange} placeholder='Search Monsters'/>
        </div>
        <CardList monsters={filteredMonsters} />
        <Footer className='footer' />
      </div>
    );
  }
}

export default App;
